import { useAuth0 } from "@auth0/auth0-react"
import * as React from "react"
import { intercomLauncherHidden } from "components/_layout/compactMenu"

export const useIntercomScript = () => {
  const [ready, setReady] = React.useState(false)
  const { user } = useAuth0()
  // Booted per account, not per user object: that object is replaced during
  // a load (boot snapshot handover, token renewal) with the same person.
  const sub = user?.sub
  const name = user?.name
  const email = user?.email
  const updatedAt = user?.updated_at

  // initialize Intercom script (customer support)
  React.useEffect(() => {
    console.log("dev mode is", import.meta.env.DEV)

    if (sub) {
      window.Intercom("boot", {
        app_id: "qpntjvwz",
        name,
        email,
        created_at: updatedAt, // Signup date as a Unix timestamp
        user_id: sub,
        hide_default_launcher: intercomLauncherHidden(),
      })

      setReady(true)
    }
    // not on updated_at alone: every load's lastOpenedAt write moves it, and
    // the token renewal after boot would then re-boot the messenger each time
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sub, name, email])

  return { intercomReady: ready }
}
